import React from "react";
import { Footer } from "../../components/footer";
import { Header } from "../../header";

import background from './img/BGContactsPage.png';
import Alena from '../main/img/Alena.png';

export const ContactsPage = () => {

  document.title = "Контакты | Сайт Алёны Швец";
  
  return (
    <section
      id="main"
      className="flex flex-col w-full bg-[#ffccfc]"
    >
      <Header page="contacts"
      fixed={false} />

      <div
        className="relative flex flex-col xl:flex-row w-full xl:h-screen bg-[#ffccfc]"
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >

        <div className="flex flex-col justify-center items-center xl:items-end w-full xl:w-1/2 px-4 py-8">

        <h1 className="font-crooker text-[25px] lg:text-[35px] xl:text-[45px] text-black text-center xl:text-left w-4/5 leading-[1]">
            Сотрудничество
          </h1>

          <p className="font-lack text-xl xl:text-3xl text-black text-center xl:text-left xl:w-4/5 cursor-pointer hover:text-sky-950 hover:underline"
          onClick={() => window.location.href = 'mailto:alyonashvets.concert@gmail.com'}>
          alyonacooperation@gmail.com
          </p>

          <h1 className="mt-16 font-crooker text-[25px] lg:text-[35px] xl:text-[45px] text-black text-center xl:text-left w-4/5 leading-[1]">
            Организация концертов
          </h1>

          <p className="font-lack text-xl xl:text-3xl text-black text-center xl:text-left xl:w-4/5 cursor-pointer hover:text-sky-950 hover:underline"
          onClick={() => window.location.href = 'mailto:alyonashvets.concert@gmail.com'}>
          alyonashvets.concert@gmail.com
          </p>

          <h1 className="mt-16 font-crooker text-[25px] lg:text-[35px] xl:text-[45px] text-black text-center xl:text-left w-4/5 leading-[1]">
          Вопросы по магазину мерча Алёны Швец
          </h1>

          <p className="font-lack text-xl xl:text-3xl text-black text-center xl:text-left xl:w-4/5 cursor-pointer hover:text-sky-950 hover:underline"
          onClick={() => window.location.href = 'https://t.me/alyonashvetsmerch_bot'}>
          t.me/alyonashvetsmerch_bot
          </p>

          <h1 className="mt-16 font-crooker text-[25px] lg:text-[35px] xl:text-[45px] text-black text-center xl:text-left w-4/5 leading-[1]">
          Менеджмент
          </h1>

          <p className="font-lack text-xl xl:text-3xl text-black text-center xl:text-left xl:w-4/5 cursor-pointer hover:text-sky-950 hover:underline"
          onClick={() => window.location.href = 'tel:+79031886673'}>
          +7 903 188 6673 (Алина)
          </p>
        </div>

        <div className="flex justify-center h-full xl:justify-end items-end w-full xl:w-1/2 px-4">
          <img
            src={Alena}
            alt="Alena"
            className="w-full h-auto max-h-[500px] xl:max-h-full object-contain"
          />
        </div>
      </div>

      <Footer />
    </section>
  );
};
